/**
 * Analytics tracking utility for fire-and-forget event tracking
 * Events are tracked asynchronously without blocking the UI
 */

import { supabase } from '../lib/supabaseClient';

export type EventType = 'view' | 'contact_click' | 'phone_reveal' | 'save' | 'share';

/**
 * Track an analytics event (fire-and-forget)
 *
 * This function is intentionally non-blocking - it does not await the database insert
 * and will fail silently to ensure analytics never breaks the user experience.
 *
 * @param eventType - The type of event being tracked
 * @param listingId - The UUID of the listing
 * @param agentId - The UUID of the agent
 * @param userId - Optional UUID of the user performing the action
 */
export function trackEvent(
  eventType: EventType,
  listingId: string,
  agentId: string,
  userId?: string
): void {
  // Fire-and-forget: execute async operation without awaiting
  supabase
    .from('analytics_events')
    .insert({
      event_type: eventType,
      listing_id: listingId,
      agent_id: agentId,
      user_id: userId ?? null,
    })
    .then(({ error }) => {
      if (error) {
        console.warn('[Analytics] Failed to track event:', error.message);
      }
    })
    .catch((err) => {
      // Catch any unexpected errors to ensure analytics never breaks the app
      console.warn('[Analytics] Unexpected error:', err);
    });
}
